<template>
  <pt-customer-sample-table class="pt-customer-sample-table__withData"  ref="table" :request-data="getDataList" :page-size="pageSize"
  :total-number="Number(totalNumber)" :table-data="tableData" :tableLabels="tableLabels">
   <template slot-scope="scope">
      <slot :row="scope.row"></slot>
    </template>
  </pt-customer-sample-table>
</template>

<script>
import PtCustomerSampleTable from './index'
export default {
  name: 'pt-customer-sample-table__withData',
  components: {
    'pt-customer-sample-table': PtCustomerSampleTable
  },
  data () {
    return {
      pageSize: 10,
      totalNumber: 0,
      tableData: [],
      currentParams: {}
    }
  },
  props: {
    tableLabels: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    buildFilterParams (page, params = {}) {
      if (Object.keys(params).length) {
        params['page'] = page
        params['size'] = this.pageSize
        return params
      } else {
        return {
          page: page,
          size: this.pageSize
        }
      }
    },
    getDataList (page, next) {
      // let data = {
      //   status: this.status.split(','),
      //   pageable: { page: page, size: this.pageSize, sort: ['createdDate,asc'] }
      // }
      let data = this.buildFilterParams(page, this.currentParams)
      this.$store.dispatch('getCustomerSamples', data).then(res => {
        next(res.data)
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.$emit('getAllSize', this.totalNumber)
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    },
    // 筛选数据的参数,不传默认为{}
    reload (params = {}) {
      this.currentParams = params
      this.$refs.table.reload()
    }
  }
}
</script>
